<template>
    <div :class="classNames">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: [
        'color',
    ],
    computed: {
        classNames() {
            let classNames = ['badge'];
            if (this.color) classNames.push(`badge--${this.color}`);

            return classNames;
        }
    },
};
</script>
